export default __webpack_public_path__ + "static/careers-world-map-e46bd5f69ff327d4ed80d884e491d82e.svg";